import {PaymentsQueries} from '../../api/payments'

export const PaymentService = {queries: PaymentsQueries}
